import { useEffect, useMemo, useRef, useState } from "react";
import { countries as allCountries, countries } from "../../global/countriesAndSources"
import {ProfileHeader } from "./profileHeader"
import { useParams } from 'react-router-dom';
import translation, { getIgo, getLangFromCountry, getTranslation } from "../../HTTP/translation";
import { fetchAllRegions } from "../../HTTP/countries";
import "./GoogleCSE.css"
import "./articles.css"
import GoogleCSE from "./GoogleCSE";
import SerperResults from "./SerperResults";
import { CountryBar } from "./countryBar";
import Map from "../Map/Map";
import { fetchLinksThematics, getSearchInCseThematic } from "../../HTTP/thematics";
import { getSerperActivation, getSerperQuota, searchWithSerper } from "../../HTTP/search";

const RESTRICTED_SEARCH_REGEX = /(adult|anal|aphro|arous|bdsm|cam(girl|sex)|dating|deepth|dildo|domin|escort|erot|explicit|fetish|fuck|gangbang|hardcore|hentai|hookup|incest|kinky|lingerie|masturb|milf|nude|nsfw|orgasm|onlyfan|porn|sex|sext|strip|sugarbaby|swinger|threesome|vagin|vibrator|webcam|xxx)/i;

export default function WhatThisCountryTalkAbout () {
    const [displayMap, setDisplayMap] = useState(false)
    const [selectedIgo, setSelectedIgo] = useState({name:"Sélectionner un Forum global", country_list: ""})
    const [selectedRegion, setSelectedRegion] = useState(null)
    const [igo, setIgo] = useState([])
    const [igoReady, setIgoReady] = useState(false)
    const [links, setLinks] = useState([])
    const [groupsLinks, setGroupsLinks] = useState([])
    const [selectedGroupLinks, setSelectedGroupLinks] = useState(0)
    const [lengthGroupsLinks, setLengthGroupsLinks] = useState(10)
    // État pour le site sélectionné dans la liste
    const [selectedSite, setSelectedSite] = useState(null);
    // État pour contrôler l'affichage du dropdown de sites
    const [showSiteDropdown, setShowSiteDropdown] = useState(false);
    const url = useMemo(() => new URL(window.location.href), []);
    const [searchQuery, setSearchQuery] = useState(sessionStorage.getItem("search_query") || "");
    const [searchInCse, setSearchInCse] = useState(false);
    const [autoSearchLaunched, setAutoSearchLaunched] = useState(false);
    const [launchSearchDone, setLaunchSearchDone] = useState(false);
    const [serperEnabled, setSerperEnabled] = useState(null);
    const [serperResults, setSerperResults] = useState([]);
    const [serperPage, setSerperPage] = useState(0);
    const [serperPageResults, setSerperPageResults] = useState({});
    const [serperLoading, setSerperLoading] = useState(false);
    const [serperError, setSerperError] = useState("");
    const [serperRequest, setSerperRequest] = useState(null);
    const [serperDelay, setSerperDelay] = useState(2);
    const [serperQuota, setSerperQuota] = useState(null);

    const refreshSerperQuota = () => {
        getSerperQuota().then(setSerperQuota).catch(() => {})
    }
    const serperRequestId = useRef(0);
    const handleSearchRef = useRef(null);
    const isRestrictedSearchEnabled = (() => {
        try {
            const localUser = JSON.parse(localStorage.getItem("user"));
            return Number(localUser?.restricted_searches) === 1;
        } catch (error) {
            return false;
        }
    })();

    // activer l'auto search si on a une query en session storage qui possede un lien avec un pipe  sans rien apres
    if (searchQuery.includes("|") && !autoSearchLaunched && !launchSearchDone) {
        console.log("activate auto search")
        setAutoSearchLaunched(true);
        setLaunchSearchDone(true);
    }

    let { countrycode } = useParams(); // Assurez-vous que le nom du paramètre correspond à celui défini dans votre route 
    
    let country = countrycode ? allCountries.find((c) => c.code === countrycode) : null
    country = country
            || JSON.parse(sessionStorage.getItem("search_country"))
            || allCountries.find((c) => c.code === JSON.parse(localStorage.getItem('user'))?.country)
            || { name: "France", code: "fr", cse: "004899679196972058950:gvpguoasgrm" }
    if (JSON.parse(sessionStorage.getItem('search_country')) === null) {
        sessionStorage.setItem('search_country',JSON.stringify(country))
    }

    const [selectedCountry] = useState(country)

    useEffect(() => {
        const regionId = new URLSearchParams(window.location.search).get("region_id");
        if (!regionId) {
            sessionStorage.removeItem("search_region");
            return;
        }

        let isMounted = true;
        fetchAllRegions()
            .then((response) => {
                const regionRows = Array.isArray(response) ? response : response?.data;
                const region = Array.isArray(regionRows)
                    ? regionRows.find((item) => String(item.id) === String(regionId))
                    : null;
                if (isMounted && region) {
                    setSelectedRegion(region);
                    sessionStorage.setItem("search_region", JSON.stringify(region));
                }
            })
            .catch((error) => console.error("Erreur lors du chargement de la région sélectionnée", error));
        return () => { isMounted = false; };
    }, []);

    const selectRegion = (region) => {
        if (!region) {
            setSelectedRegion(null);
            sessionStorage.removeItem("search_region");
            const clearedUrl = new URL(window.location.href);
            clearedUrl.searchParams.delete("region_id");
            window.history.pushState({}, "", clearedUrl);
            return;
        }
        setSelectedRegion(region);
        sessionStorage.removeItem("search_igo");
        sessionStorage.removeItem("selected_igo");
        sessionStorage.setItem("search_region", JSON.stringify(region));
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("region_id", region.id);
        nextUrl.searchParams.delete("igo");
        window.history.pushState({}, "", nextUrl);
    };
    

    const handleSiteSelect = (site) => {
        setSelectedSite(site);
        if (site === null) {
            url.searchParams.delete('link-id')
            window.history.pushState({}, '', url);
            sessionStorage.removeItem('selected_site')
        } else {
            url.searchParams.set('link-id', site.id)
            window.history.pushState({}, '', url);
            sessionStorage.setItem('selected_site', JSON.stringify(site))
        }
        setShowSiteDropdown(false);
    };


	// 1. Modifiez votre fonction handleSearch pour stocker aussi le site sélectionné
	const handleSearch = async () => {
        if (serperEnabled === null) {
            setSerperError("Le moteur de recherche n'est pas encore disponible.")
            return
        }

		// Si nécessaire, traduisez la requête avant de la soumettre
		let finalQuery = searchQuery;

        if (isRestrictedSearchEnabled && RESTRICTED_SEARCH_REGEX.test(finalQuery)) {
            alert("Cette recherche est restreinte pour votre compte.");
            setSearchQuery("");
            sessionStorage.removeItem("search_query");
            const googleInput = document.querySelector("input#gsc-i-id1");
            const customInput = document.querySelector("input#custom-search-input");
            if (googleInput) googleInput.value = "";
            if (customInput) customInput.value = "";
            return;
        }
		
		if (document.getElementById("translate_query") && document.getElementById("translate_query").checked) {
		try {
            // si dans la recher on a un pipe | on ne traduit que la partie après le pipe et remettre le tout ensemble
            let queryToTranslate = searchQuery;
            let beforePipe = "";
            if (searchQuery.includes("|")) {
                queryToTranslate = searchQuery.split("|")[1].trim();
                beforePipe = searchQuery.split("|")[0].trim();
            }
			const langDest = await getLangFromCountry(selectedCountry.code);
			const translated = await getTranslation(
			sessionStorage.getItem("currentlanguage"),
			langDest,
			queryToTranslate
			);
            finalQuery = beforePipe.length > 0 ? beforePipe + " | " + translated : translated;
			setSearchQuery(finalQuery); // Mettez à jour le champ de recherche avec la traduction
		} catch (error) {
			console.error("Erreur lors de la traduction:", error);
		}
		}

        if (isRestrictedSearchEnabled && RESTRICTED_SEARCH_REGEX.test(finalQuery)) {
            alert("Cette recherche est restreinte pour votre compte.");
            setSearchQuery("");
            sessionStorage.removeItem("search_query");
            const googleInput = document.querySelector("input#gsc-i-id1");
            const customInput = document.querySelector("input#custom-search-input");
            if (googleInput) googleInput.value = "";
            if (customInput) customInput.value = "";
            return;
        }
		
		// Stockez la requête simple dans sessionStorage
		sessionStorage.setItem("search_query", finalQuery);
		
		// Stockez aussi le site sélectionné s'il existe
		if (selectedSite) {
		sessionStorage.setItem("selected_site", JSON.stringify(selectedSite));
		} else {
		sessionStorage.removeItem("selected_site"); // Supprimer si pas de site sélectionné
		}
		
        const linksToSearch = selectedSite
            ? [selectedSite.link]
            : !searchInCse
                ? (groupsLinks[Number(selectedGroupLinks)] || []).map((link) => link.link)
                : [];

        if (selectedIgo.name !== "Sélectionner un Forum global" && selectedCountry.code === "wd" && !sessionStorage.getItem("thematic")) {
            finalQuery = `site:${selectedIgo.link} ${finalQuery}`;
        }

        if (serperEnabled) {
            await runSerperSearch(finalQuery, linksToSearch, 1, true)
            return
        }

        if (selectedSite) {
            finalQuery = `site:${selectedSite.link} ${finalQuery}`;
        } else if (!searchInCse) {
            const linksToUse = groupsLinks[Number(selectedGroupLinks)] || [];
            if (linksToUse.length > 0) {
                const sitePrefixes = linksToUse.map(link => `site:${link.link}`).join(' OR ');
                finalQuery = `(${sitePrefixes}) ${finalQuery}`;
            }
        }

        const googleInput = document.querySelector("input#gsc-i-id1");
        const googleButton = document.querySelector("button.gsc-search-button-v2");
        if (googleInput && googleButton) {
            googleInput.value = finalQuery;
            googleButton.click();
        }
	};
    handleSearchRef.current = handleSearch;

    const runSerperSearch = async (q, searchLinks, page, forceRefresh = false, delay = serperDelay) => {
        const requestId = ++serperRequestId.current
        const request = { q, country: selectedCountry.code, links: searchLinks, delay }
        const requestKey = JSON.stringify(request)
        if (!forceRefresh && serperPageResults[requestKey]?.[page]) {
            setSerperPage(page)
            setSerperRequest(request)
            setSerperResults(serperPageResults[requestKey][page])
            setSerperError("")
            setSerperLoading(false)
            return
        }

        setSerperLoading(true)
        setSerperError("")
        setSerperResults([])
        setSerperPage(page)
        setSerperRequest(request)
        if (forceRefresh) {
            setSerperPageResults({ [requestKey]: {} })
        }

        try {
            const response = await searchWithSerper({
                ...request,
                page,
            })
            if (!Array.isArray(response?.results)) {
                throw new Error("La réponse du moteur de recherche est invalide.")
            }
            if (requestId === serperRequestId.current) {
                setSerperResults(response.results)
                setSerperPageResults((cachedPages) => ({
                    ...cachedPages,
                    [requestKey]: {
                        ...(forceRefresh ? {} : cachedPages[requestKey]),
                        [page]: response.results,
                    },
                }))
            }
        } catch (error) {
            if (requestId === serperRequestId.current) {
                setSerperError(error.message || "La recherche a échoué.")
            }
        } finally {
            if (requestId === serperRequestId.current) {
                setSerperLoading(false)
            }
            refreshSerperQuota()
        }
    }

    const changeSerperPage = (page) => {
        if (!serperRequest || page < 1) return
        setSerperPage(page)
        runSerperSearch(serperRequest.q, serperRequest.links, page, false, serperRequest.delay)
    }

    useEffect(() => {
        let isMounted = true
        getSerperActivation()
            .then((isEnabled) => {
                if (isMounted) setSerperEnabled(isEnabled)
                if (isMounted && isEnabled) refreshSerperQuota()
            })
            .catch((error) => {
                console.error("Erreur lors de la lecture de l'option Serper:", error)
                if (isMounted) setSerperError(error.message || "Impossible de déterminer le moteur de recherche.")
            })
        return () => { isMounted = false }
    }, [])

    useEffect(() => {
        const funIgo = async () => {
            const res = await getIgo()
            setIgo(res)
            const url = new URL(window.location.href)
            if (url.searchParams.has('region_id')) {
                setSelectedIgo({ name: "Sélectionner un Forum global", country_list: "" })
            } else if (url.searchParams.get('igo') !== null) {
                const igoSelected = res.find((i) => i.name === url.searchParams.get('igo'))
                if (igoSelected) {
                    setSelectedIgo(igoSelected)
                } else {
                    url.searchParams.delete('igo')
                    setSelectedIgo(res[0])
                }
            } else if (sessionStorage.getItem('search_igo') !== null) {
                const igoFound = res.find((i) => i.name === sessionStorage.getItem('search_igo'))
                if (igoFound) {
                    setSelectedIgo(igoFound)
                } else {
                    sessionStorage.removeItem('search_igo')
                    setSelectedIgo(res[0])
                }
            } else {
                setSelectedIgo(res[0])
            }
        }
        const fetchLinks = async () => {
			try {
				const response = await fetchLinksThematics(sessionStorage.getItem('thematic'), selectedCountry.code, sessionStorage.getItem('search_igo'))
				if (response) {
					setLinks(response)
                    // Group links by lengthGroupsLinks
                    const grouped = response.reduce((acc, link, index) => {
                        const groupIndex = Math.floor(index / lengthGroupsLinks);
                        if (!acc[groupIndex]) {
                            acc[groupIndex] = [];
                        }
                        acc[groupIndex].push(link);
                        return acc;
                    }, []);
                    console.log("grouped", grouped)
                    setGroupsLinks(grouped);
				}
				const selectedLinkId = url.searchParams.get('link-id')
				console.log("selectedLinkId", selectedLinkId)
				console.log("response", response)
				if (selectedLinkId) {
					const selectedLink = response.find(link => link.id === parseInt(selectedLinkId))
					console.log("selectedLink", selectedLink)
					if (selectedLink) {
						setSelectedSite(selectedLink)
					} else {
						setSelectedSite({})
						url.searchParams.delete('link-id')
						window.history.pushState({}, '', url);
						sessionStorage.removeItem('selected_site')
					}
				}
			} catch (error) {
				console.error("Error fetching thematic links:", error)
			}
		}
        const fetchSearchInCse = async () => {
            try {
                const response = await getSearchInCseThematic(sessionStorage.getItem('thematic'), selectedCountry.code)
                setSearchInCse(Number(response?.search_in_cse) === 1)
            } catch (error) {
                console.error("Error fetching search in CSE:", error)
            }
        }
        fetchSearchInCse()
		fetchLinks()
        funIgo()
        setIgoReady(true)
    }, [selectedCountry, url])

    useEffect(() => {
        if (serperEnabled && autoSearchLaunched) {
            setAutoSearchLaunched(false)
            handleSearchRef.current()
        }
    }, [serperEnabled, autoSearchLaunched])

    if (sessionStorage.getItem('search_country_country') !== null) {
        sessionStorage.removeItem('search_country_country')
    }
    if (sessionStorage.getItem('search_themes_country') !== null) {
        sessionStorage.removeItem('search_themes_country')
    }
    sessionStorage.setItem('listmiddle', "De quoi parle-t-on ?")

    

    const selectNewCountry = async (country) => {
        const langDest = await translation.getLangFromCountry(country.code)
        let trad
        if (langDest !== document.documentElement.lang) trad = await translation.getTranslation(document.documentElement.lang, langDest, country.name)
        const regionQuery = selectedRegion ? `?region_id=${encodeURIComponent(selectedRegion.id)}` : ""
        window.location.href = `/${country.code}/what-this-country-talk-about${regionQuery}`
        sessionStorage.setItem("search_country", JSON.stringify(country))
    }

    const handleDisplayMap = () => {
		if(displayMap) {
			setDisplayMap(false)
		} else {
			setDisplayMap(true)
		}
	}
    
    const currentThematicId = sessionStorage.getItem("thematic")
    const currentThematicName = currentThematicId ? (sessionStorage.getItem("thematic_name") || currentThematicId) : null
    let thematicPath = []
    try {
        thematicPath = JSON.parse(sessionStorage.getItem("thematic_path")) || []
    } catch {
        thematicPath = []
    }
    const thematicLabel = currentThematicName && thematicPath.length > 0 && thematicPath[thematicPath.length - 1] === currentThematicName
        ? thematicPath.join(" > ")
        : currentThematicName
    const selectedTheme = thematicLabel ? `Zemus Search | ${thematicLabel}` : "Zemus Search"

    return (
        <>
        <ProfileHeader 
                selectedTheme={selectedTheme}
                wideSearch
                selectedCountry={selectedCountry} 
                setSelectedCountry = {(country) => selectNewCountry(country)}
                igo = {igo}
                igoReady = {igoReady}
                selectedIgo = {selectedIgo}
                setSelectedIgo = {(igo) => setSelectedIgo(igo)}
                selectedRegion = {selectedRegion}
                setSelectedRegion = {selectRegion}
                links = {links}
                setLinks = {(links) => setLinks(links)}
                groupsLinks = {groupsLinks}
                setGroupsLinks = {(groups) => setGroupsLinks(groups)}
                selectedGroupLinks = {selectedGroupLinks}
                setSelectedGroupLinks = {(group) => setSelectedGroupLinks(group)}
                lengthGroupsLinks = {lengthGroupsLinks}
                selectedSite = {selectedSite}
                setSelectedSite = {(site) => handleSiteSelect(site)}
                searchInCse = {searchInCse}
                serperEnabled = {serperEnabled === true}
                serperDelay = {serperDelay}
                setSerperDelay = {(delay) => setSerperDelay(Number(delay))}
                showSiteDropdown = {showSiteDropdown}
                setShowSiteDropdown = {(show) => setShowSiteDropdown(show)}
                handleSiteSelect = {(site) => handleSiteSelect(site)}
                searchQuery = {searchQuery}
                setSearchQuery = {(query) => setSearchQuery(query)}
                handleSearch = {handleSearch}
                displayMap = {() => handleDisplayMap()}
            />
        <div className="flex">
            <div className="flex-1">
                {
                    (selectedRegion || selectedIgo.name !== "Sélectionner un Forum global") && (
                        <>
                            <div className="flex flex-col-reverse xl:flex-row xl:justify-between items-center ml-2 mr-2">
                                <h2 className=" text-sm xl:text-xl "><button className="underline" onClick={
                                    () => {
                                        sessionStorage.removeItem('search_themes_country')
                                        sessionStorage.removeItem('search_country_country')
                                        sessionStorage.setItem("search_country", JSON.stringify(countries.find(c => c.code === 'wd')))
                                        sessionStorage.setItem("search_query", "")
                                        sessionStorage.removeItem('thematic')
                                        sessionStorage.removeItem('search_region')
                                        window.location.href = "/"
                                    }
                                }>{selectedRegion ? selectedRegion.name : (selectedIgo.label || selectedIgo.name)}</button>
                                <button
                                    type="button"
                                    className="ml-2 font-bold"
                                    style={{ color: "#000" }}
                                    aria-label="Retirer la sélection de la recherche"
                                    title="Retirer la sélection de la recherche"
                                    onClick={() => {
                                        sessionStorage.setItem("search_query", "")
                                        sessionStorage.removeItem("search_igo")
                                        sessionStorage.removeItem("selected_igo")
                                        sessionStorage.removeItem("search_region")
                                        sessionStorage.removeItem("thematic")
                                        window.location.href = "/search"
                                    }}
                                >✕</button></h2>
                                {
                                    !selectedRegion && selectedIgo.image && (
                                        <a href={selectedIgo.link} target="_blank" rel="noopener noreferrer"><img className="w-auto h-16 xl:h-20" src={selectedIgo.image} alt={"Logo " + selectedIgo.name} /></a>
                                    )
                                }
                            </div>
                        </>
                    )
                }
                <Map 
                    selectedCountry={selectedCountry} 
                    setSelectedCountry = {(country) => selectNewCountry(country)}
                    displayMap = {displayMap}
                    setDisplayMap = {(hide) => setDisplayMap(hide)}
                />
                <div className="max-h-[75vh] overflow-y-auto">
                    {serperEnabled === true && serperQuota && (
                        <p className="text-sm text-gray-600 px-2">
                            {serperQuota.used}/{serperQuota.limit} recherches utilisées ce mois-ci
                            {serperQuota.credits > 0 && ` · ${serperQuota.credits} recherches achetées`}
                        </p>
                    )}
                    {serperEnabled === true ? (
                        <SerperResults
                            results={serperResults}
                            page={serperPage}
                            loading={serperLoading}
                            error={serperError}
                            onPageChange={changeSerperPage}
                            country={selectedCountry}
                        />
                    ) : serperEnabled === false ? (
                        <GoogleCSE
                            selectedCountry={country}
                            selectedSite={selectedSite}
                            autoSearchLaunched={autoSearchLaunched}
                            setAutoSearchLaunched={(value) => setAutoSearchLaunched(value)}
                        />
                    ) : (
                        <SerperResults
                            results={[]}
                            page={0}
                            loading={!serperError}
                            error={serperError}
                            onPageChange={() => {}}
                        />
                    )}
                </div>
            </div>
            <div id="pays_large" className="w-60 bg-neutral-50">
            <CountryBar
                selectedCountry = {country}
                setSelectedCountry = {(country) => selectNewCountry(country)}
                selectedIgo = {selectedIgo}
                setSelectedIgo = {(igo) => setSelectedIgo(igo)}
                selectedRegion = {selectedRegion}
                setSelectedRegion = {selectRegion}
                displayMap = {() => handleDisplayMap()}
                isMobile = {false}
                igo = {igo}
                igoReady = {igoReady}
            />
            </div>
        </div>
        </>
    )
}
